"use client";

import styles from "./GreyCards.module.css";
import MaxWidth from "@/components/MaxWidth";
import { stripOuterPTag } from "@/lib/utils/stripOuterPTag";
import { Header3, P2, Link } from "@bumble/ui-kit";
export default function GreyCards({
  data
}: any) {
  const {
    cards
  } = data || {};
  return <MaxWidth>
      <div className={styles.wrapper}>
        {cards.map((card: any) => <div key={card.id} className={styles.card}>
            <Header3>{card.title}</Header3>
            <br />
            <span className={styles.description}>
              <P2 html={stripOuterPTag(card.text)} />
            </span>
            <br />
            <span className={styles.cta}>
              {card.cta?.link ? <Link href={card.cta?.link} title={card.cta.text} extraClass="" isDecorated={false} onClick={() => {}}>
                  {card.cta.text}
                </Link> : null}
            </span>
          </div>)}
      </div>
    </MaxWidth>;
}